import { CircularProgress, Stack, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../locales/tokens";
import { getStyles } from "./styles";
import { TabSelector } from "../../../../ui-kit/tabSelector/tabSelector";
import { OrdersTable } from "./components/ordersTable";
import { SearchInput } from "../../../../ui-kit/searchInput/searchInput";
import { EmptyPage } from "../../../content/category/categoryEmpty/ui";
import { useOrderHistory } from "../presenters/useOrderHistory";

export const UserOrderHistory: FC = () => {
    const { t } = useTranslation();
    const styles = useMemo(() => getStyles(), []);
    const { activeTab, isOrderLoading, isRequestList, orderList, page, pageAmount, search, onSearch, onChangePage, onToggleTab, onProcessedOrder, singleUser, scrollRef } = useOrderHistory();

    const tabOptions = [
        { label: t(tokens.order.title.new), value: "NEW" },
        { label: t(tokens.order.title.processed), value: "PROCESSED" },
    ];

    return (
        <Stack m={2}>
            <Stack>
                <Typography variant="h5" fontWeight={600}>{t(tokens.order.title.ordersHistory)}</Typography>
                <Typography variant="body2" fontWeight={600}>Деталі: {singleUser?.last_name + " " + singleUser?.first_name + " " + singleUser?.patronymic}</Typography>
            </Stack>
            <Stack mt={3}>
                <SearchInput
                    searchText={search}
                    label={t(tokens.order.title.searchOrder)}
                    handleSearch={onSearch}
                    size="small"
                />
            </Stack>
            <TabSelector tab={activeTab} tabOptions={tabOptions} handleTabsChange={onToggleTab} />
            {orderList?.length > 0 &&
                <OrdersTable
                    scrollRef={scrollRef}
                    orders={orderList}
                    page={page}
                    pageAmount={pageAmount}
                    handlePageChange={onChangePage}
                    onProcessedOrder={onProcessedOrder}
                />
            }
            {(!orderList?.length && isOrderLoading) &&
                <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={styles.progressWrapper}
                >
                    <CircularProgress color="primary" />
                </Stack>
            }
            {(!orderList?.length && !isOrderLoading) &&
                <Stack pt={2}>
                    <EmptyPage
                        title={t(tokens.users.ordersHistory.emptyListTitle)}
                        description={t(tokens.users.ordersHistory.emptyListDescription)}
                    />
                </Stack>
            }
        </Stack>
    )
};